import React from "react";
import { ResponsivePie } from "@nivo/pie";
import { styled, useTheme } from "@material-ui/styles";

import { Card, Theme } from "@material-ui/core";

import Typography from "../typography";
import { IStyledArguments } from "../../types/styled-arguments";
import { injectIntl } from "react-intl";

import messages from "./PageViewTeam.intl";

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.

const CardWrapper = styled(Card)(({ theme }: IStyledArguments) => ({
  background: theme.palette.background.paper,
  borderRadius: 16,
  border: `1px solid ${theme.palette.extra.borderColor}`,
  boxShadow: "0 1px 3px rgba(16, 21, 26, 0.06)",
  flexDirection: "column",
  height: "100%",
  display: "flex",
  transition: "box-shadow 0.2s ease",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(16, 21, 26, 0.08)",
  },
  [theme.breakpoints.down("sm")]: {
    borderRadius: "16px",
  },
}));

const Header = styled("div")(({ theme }: IStyledArguments) => ({
  background: theme.palette.background.paper,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(2.5, 3),
  borderBottom: `1px solid ${theme.palette.extra.borderColor}`,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

const GraphWrapper = styled("div")(({ theme }: IStyledArguments) => ({
  width: "100%",
  height: "350px",
  padding: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    height: "300px",
  },
}));

const GamesChart = injectIntl(({ data, intl }: any) => {
  const theme = useTheme<Theme>();
  const colors: Record<string, string> = {
    lost: theme.palette.extra.loss,
    drawn: theme.palette.extra.draw,
    won: theme.palette.extra.win,
  };
  const getColor = (bar: any) => colors[bar.id];

  return (
  <CardWrapper>
    <Header>
      <Typography.H6 style={{
        fontWeight: 700,
        color: theme.palette.primary.main,
        margin: 0,
      }}>
        {intl.formatMessage(messages.statisticsTitle)}
      </Typography.H6>
    </Header>
    <GraphWrapper>
      <ResponsivePie
        data={data}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        // colors={{ scheme: "pastel1" }}
        colors={getColor}
        borderWidth={1}
        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
        radialLabelsSkipAngle={10}
        radialLabelsTextXOffset={6}
        radialLabelsTextColor={theme.palette.text.primary}
        radialLabelsLinkOffset={0}
        radialLabelsLinkDiagonalLength={16}
        radialLabelsLinkHorizontalLength={24}
        radialLabelsLinkStrokeWidth={1}
        radialLabelsLinkColor={{ from: "color" }}
        slicesLabelsSkipAngle={10}
        slicesLabelsTextColor={theme.palette.text.primary}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            size: 4,
            padding: 1,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            rotation: -45,
            lineWidth: 6,
            spacing: 10,
          },
        ]}
        fill={[
          // {
          //   match: {
          //     id: "drawn",
          //   },
          //   id: "dots",
          // },

          {
            match: {
              id: "lost",
            },
            id: "lines",
          },
        ]}
        // legends={[
        //   {
        //     anchor: "bottom",
        //     direction: "row",
        //     translateY: 56,
        //     itemWidth: 100,
        //     itemHeight: 18,
        //     itemTextColor: "#999",
        //     symbolSize: 18,
        //     symbolShape: "circle",
        //     effects: [
        //       {
        //         on: "hover",
        //         style: {
        //           itemTextColor: "#000",
        //         },
        //       },
        //     ],
        //   },
        // ]}
      />
    </GraphWrapper>
  </CardWrapper>
  );
});

export default GamesChart;
